import { render } from "./HomeCard.vue?vue&type=template&id=5bbdbe10&scoped=true"
import script from "./HomeCard.vue?vue&type=script&lang=js"
export * from "./HomeCard.vue?vue&type=script&lang=js"

import "./HomeCard.vue?vue&type=style&index=0&id=5bbdbe10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbdbe10"]])

export default __exports__